<template>
  <div class="sign-in">
    <schoolCommonImage />
    <el-card class="box-card" v-for="(item, index) of studentObjectList" :key="item.id">
        <div class="section">
            <p>{{item.name}}</p>
            <div>
                <el-button :type="item.is_sign ? 'warning' : ''" @click="updateStudentSign(item, true, index)">已到</el-button>
                <el-button :type="!item.is_sign ? 'warning' : ''" @click="updateStudentSign(item, false, index)">未到</el-button>
            </div>
        </div>
    </el-card>
    <div class="btn">
      <el-button type="success" plain @click="goStartClass">去授课</el-button>
    </div>
  </div>
</template>
<script>
import schoolCommonImage from "@/components/schoolCommonImage";
import { getPrepareStudentSignIn, updateStudentSign } from "@/api/educational.js"
export default {
  name: "sign-in",
  components: {
    schoolCommonImage
  },
  data() {
    return {
      studentObjectList: []
    };
  },
  mounted() {
      this.init();
  },
  methods: {
    goStartClass() {
      window.open(this.$route.query.url)
    },
    updateStudentSign(row, status, index) {
        updateStudentSign({
            student_id: row.id,
            classes_id: this.$route.query.class_code,
            teaching_plan_id: this.$route.query.id,
            is_sign: status
        }).then(() => {
            this.studentObjectList[index].is_sign = status;
        })
    },
    init() {
        getPrepareStudentSignIn({
            classes_id: this.$route.query.class_code
        }).then(res => {
            this.studentObjectList = res.studentObjectList
        })
    },
  },
};
</script>

<style scoped lang="scss">
.sign-in{
  min-width: 1000px;
  max-width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  .box-card{
    margin: 20px 0;
    .section{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .btn{
    float: right;
  }
}
</style>
